<template>
  <div class="max-content">
    <xibeihui v-if="meeting_id == 472"></xibeihui>
    <meeting584 v-else-if="meeting_id == 584"></meeting584>
    <meeting596 v-else-if="meeting_id == 596"></meeting596>
    <XVC2025 v-else-if="meeting_id == 598"></XVC2025>
    <meeting602 v-else-if="meeting_id == 602"></meeting602>
    <meeting711 v-else-if="meeting_id == 711"></meeting711>
    <meeting717 v-else-if="meeting_id == 717"></meeting717>
    <meeting788 v-else-if="meeting_id == 788"></meeting788>
    <meeting787 v-else-if="meeting_id == 787"></meeting787>
    <meeting674 v-else-if="meeting_id == 674"></meeting674>
    <meeting790 v-else-if="meeting_id == 790"></meeting790>
    <meeting809 v-else-if="meeting_id == 809"></meeting809>
    <meeting811 v-else-if="meeting_id == 811"></meeting811>
    <meeting824 v-else-if="meeting_id == 824"></meeting824>



    <div
      class="meeting-details"
      v-else
      :style="
        meeting_id == 513
          ? { 'background-image': 'url(' + meeting_bg_513 + ')' }
          : home_bg_img
            ? { 'background-image': 'url(' + home_bg_img + ')' }
            : home_bg_color
              ? { 'background-color': home_bg_color }
              : ''
      "
    >
      <div class="content">
        <top-image :images="images"></top-image>
        <div class="banner-show">
          <div class="cover">
            <van-swipe
              :autoplay="3000"
              indicator-color="white"
              :show-indicators="false"
            >
              <van-swipe-item
                v-for="(item, key, index) in swiperImg"
                :key="index"
                @click="clickSwiperImg(item)"
              >
                <img :src="item.image" alt="" />
              </van-swipe-item>
            </van-swipe>
            <p v-if="show_views" class="views">
              <van-icon name="eye-o" style="margin-right: 5px" />{{ views }}
            </p>
          </div>
        </div>
        <!-- 搜索框显示判断 -->
        <div class="search" v-if="search_writer_show == 1">
          <div class="head">
            <van-search
              shape="round"
              v-model="name"
              placeholder="请输入专家姓名/医院名称"
              @search="searchExpert"
            />
          </div>
        </div>
        <div class="adver_img" v-if="meeting_id == 437">
          <img src="@/assets/images/System/adver_m.png" alt="" />
        </div>
        <div v-if="meetingButton.length != 0">
          <div v-if="meeting_id == 484" class="relation">
            <a
              :style="{
                width:
                  item.id == 1830 || item.id == 1832
                    ? '50%'
                    : button_rows == 4 && item.icon_type != 2
                      ? '25%'
                      : button_rows == 4 && item.icon_type == 2
                        ? '50%'
                        : button_rows == 3 && item.icon_type != 2
                          ? '33.3%'
                          : '66.6%',
              }"
              href="Javascript:void(0)"
              v-for="(item, index) in meetingButton"
              :key="index"
              title="picname"
              @click="skipLink(item)"
            >
              <img
                v-if="item.id == 1830"
                src="../../../assets/images/Meeting/button_1832.png"
                alt=""
              />
              <img
                v-else-if="item.id == 1832"
                src="../../../assets/images/Meeting/button_1830.png"
                alt=""
              />
              <img v-else :src="item.icon" alt="" />

              <p
                style="color: black; font-size: 0.4rem"
                v-if="show_button_text"
              >
                {{ item.name }}
              </p>
            </a>
          </div>
          <button590
            v-else-if="meeting_id == 590"
            :meetingButton="meetingButton"
            :showButtonText="show_button_text"
          ></button590>
          <button563
            v-else-if="meeting_id == 563"
            :meetingButton="meetingButton"
            :showButtonText="show_button_text"
          ></button563>
          <button581
            v-else-if="meeting_id == 581"
            :meetingButton="meetingButton"
            :showButtonText="show_button_text"
          ></button581>
          <button612
            v-else-if="meeting_id == 612"
            :meetingButton="meetingButton"
            :showButtonText="show_button_text"
          ></button612>
          <button656
            v-else-if="meeting_id == 656"
            :meetingButton="meetingButton"
            :showButtonText="show_button_text"
          ></button656>
          <button659
            v-else-if="meeting_id == 659"
            :meetingButton="meetingButton"
            :showButtonText="show_button_text"
          ></button659>
          <button666
            v-else-if="meeting_id == 666"
            :meetingButton="meetingButton"
            :showButtonText="show_button_text"
          ></button666>
          <button676
            v-else-if="meeting_id == 676"
            :meetingButton="meetingButton"
            :showButtonText="show_button_text"
          ></button676>

          <div
            v-else
            class="relation"
            :class="meeting_id == 580 ? 'relation_580' : ''"
            :style="
              meeting_id == 513
                ? 'justify-content:space-around;padding-bottom:130px;position:relative;'
                : ''
            "
          >
            <a
              :style="{
                width:
                  button_rows == 4 && item.icon_type != 2
                    ? '25%'
                    : button_rows == 4 && item.icon_type == 2
                      ? '50%'
                      : button_rows == 3 && item.icon_type != 2 && item.icon_type_pos != 2
                        ? '33.3%'
                        : '66.6%',
                        
              }"
              href="Javascript:void(0)"
              v-for="(item, index) in meetingButton"
              :key="index"
              title="picname"
              :class="item.id == 2101 ? 'sp_btn' : ''"
              @click="skipLink(item)"
            >
              <img
                :style="meeting_id == 513 ? 'width:70%;margin-top:20px' : ''"
                :src="item.icon"
                alt=""
              />
              <p
                style="color: black; font-size: 0.4rem"
                v-if="show_button_text"
              >
                {{ item.name }}
              </p>
            </a>
          </div>
        </div>
      </div>
      <bottom
        :name="meeting_name"
        :meeting_id="meeting_id"
        :show_support="show_support"
        v-if="bottom_word_show && !home_bg_img"
      >
      </bottom>
    </div>
  </div>
</template>
<script>
// import Register from "../../components/Users/Register.vue"
import {
  MeetingButtons,
  MeetingsCarousel,
  MeetingsDetails,
  companyImages,
} from "../../../config/interface.js";
import { ImagePreview } from "vant"; //预览图片   使用的函数调用
import TopImage from "../components/TopImage.vue";
import Bottom from "./Bottom.vue";
import Xibeihui from "@/pages/xbh2024/index.vue";
import Button590 from "../components/Meeting/Button590.vue";
import Button563 from "../components/Meeting/Button563.vue";
import Button581 from "../components/Meeting/Button581.vue";
import Button612 from "../components/Meeting/Button612.vue";
import Button656 from "../components/Meeting/Button656.vue";
import Button659 from "../components/Meeting/Button659.vue";
import Button666 from "../components/Meeting/Button666.vue";
import Button676 from "../components/Meeting/Button676.vue";

import Meeting584 from "../Meeting584/index.vue";
import Meeting596 from "../Meeting596/index.vue";
import Meeting602 from "../Meeting602/index.vue";
import Meeting711 from "../Meeting711/index.vue";
import Meeting717 from "../Meeting717/index.vue";
import Meeting788 from "../Meeting788/index.vue";
import Meeting787 from "../Meeting787/index.vue";
import Meeting674 from "../Meeting674/index.vue";
import Meeting790 from "../Meeting790/index.vue";
import Meeting809 from "../Meeting809/index.vue";
import Meeting811 from "../Meeting811/index.vue";
import Meeting824 from "../Meeting824/index.vue";



import XVC2025 from "@/pages/XVC/index598.vue";

export default {
  components: {
    TopImage,
    Bottom,
    Xibeihui,
    Button590,
    Button563,
    Meeting584,
    Meeting596,
    Meeting602,
    Meeting711,
    Meeting717,
    Meeting788,
    Meeting787,
    Meeting674,
    Meeting790,
    Meeting809,
    Meeting811,
    Meeting824,

    Button581,
    Button656,
    Button659,
    Button612,
    Button666,
    Button676,
    XVC2025,
  },
  data() {
    return {
      meetingButton: [], //会议按钮
      button_rows: 3, //menu一行按钮数
      swiperImg: [],
      images: [],
      show_button_text: 0,
      meeting_name: "",
      views: 0,
      show_views: 0,
      bottom_word_show: 0,
      show_support: 1,
      meeting_bg_513: require("../../../assets/images/Meeting/meeting_bg_513.png"),
      name: "",
      search_writer_show: false,
      home_bg_color: "", //背景色
      home_bg_img: "", //背景图
    };
  },
  beforeRouteEnter(to, from, next) {
    //  修复iOS版微信HTML5 History兼容性问题
    if (to.path !== location.pathname) {
      location.assign(to.fullPath);
    } else {
      next();
    }
  },
  mounted() {
    // console.log(this.$route)
    // this.meeting_id=this.$route.query.meeting_id;
    this.getMeetingDetails();
    this.getMeetingButtons(this.meeting_id);
    this.getMeetingCarousel();
    this.getImages();
  },
  computed: {
    meeting_id() {
      return this.$route.query.meeting_id
        ? this.$route.query.meeting_id
        : this.$route.query.id
          ? this.$route.query.id
          : this.$route.query.MT_id;
    },
  },
  methods: {
    getImages() {
      const url = companyImages;
      let params = {
        meeting_id: this.meeting_id,
      };
      const method = "POST";
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          this.images = res.data;
        }
      });
    },
    //跳转链接
    skipLink(item) {
      console.log(item);
      if (item.url.match(/\.(jpeg|jpg|gif|png)$/)) {
        ImagePreview({
          images: [item.url],
          closeable: true,
          showIndex: false,
        });
      }
      //  else if(item.button_type==9){
      // 	window.location.href='/vascularNews/meeting/files?meeting_id='+this.meeting_id+'&button_id='+item.id;
      // }
      else {
        window.localStorage.removeItem("callback_url");
        window.localStorage.setItem("callback_url", item.url);
        window.location.href = item.url;
        if (
          item.url.indexOf("vascularnews/meeting/schedule") > -1 &&
          window.localStorage.getItem("schedule_date")
        ) {
          window.localStorage.removeItem("schedule_date");
        }
      }
    },
    searchExpert(val) {
      console.log("keywords", val);
      this.$router.push(
        "/vascularNews/expert/search?meeting_id=" +
          this.meeting_id +
          "&keywords=" +
          val,
      );
    },
    //会议轮播
    getMeetingCarousel() {
      const url = MeetingsCarousel;
      let params = {
        meeting_id: this.meeting_id,
      };
      const method = "POST";
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          if (this.meeting_id == 563) {
            delete data["632"];
          }
          if (this.meeting_id == 709) {
            this.swiperImg = [
              {
                image:
                  "https://cdn.edstatic.com/203012120000/e9d03f832d7aefb3314924820f21ad2a/2026/03/053c2fdb-6413-4cc4-a3c6-3c7a21641de3.jpg",
              },
            ];
          } else {
            this.swiperImg = data;
          }
        }
      });
    },
    //点击轮播图跳转
    clickSwiperImg(item) {
      window.location.href = item.link;
    },
    //会议按钮
    getMeetingButtons(id) {
      const url = MeetingButtons;
      const method = "POST";
      let params = {
        meeting_id: id,
      };
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          for (let i in data) {
            var obj = {
              url: data[i].url,
              name: data[i].name,
              icon: data[i].icon,
              button_type: data[i].button_type,
              id: data[i].id,
              icon_type: data[i].icon_type,
              icon_type_pos: data[i].icon_type_pos,
            };
            this.meetingButton.push(obj);
          }
        }
      });
    },
    //会议详情
    getMeetingDetails(id) {
      const url = MeetingsDetails;
      const method = "POST";
      let params = {
        meeting_id: this.meeting_id,
      };
      fetch(url, params, method).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          document.title = data.name;

          this.home_bg_img = data.home_bg_img;
          this.home_bg_color = data.home_bg_color;
          this.meeting_name = data.name;
          this.button_rows = data.button_rows;
          this.show_button_text = data.show_button_text;
          this.show_views = data.show_views;
          this.views = data.views;
          this.bottom_word_show = data.bottom_word_show;
          this.show_support = data.platform_support_show;
          this.search_writer_show = data.search_writer_show;

          //微信浏览器  请求jsdk
          if (common.is_weixin()) {
            common.wxShare(data.name, data.title, data.shareimg);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.meeting-details {
  overflow: hidden;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: top center;
  height: 100%;

  .content {
    min-height: calc(100vh - 80px);
  }

  .banner-show {
    width: 100%;
    // height:210px;
    // padding: 0px 12px;

    .cover {
      width: 100%;
      // height:210px;
      position: relative;

      // margin-bottom:14px;
      img {
        width: 100%;
        // height:210px;
      }
    }
  }

  .relation {
    overflow: auto;
    padding: 0.3rem 0.3rem 0 0.3rem;
    @include flex(row);
    align-items: center;
    flex-wrap: wrap;

    div {
      text-align: center;
    }

    a {
      box-sizing: border-box;
      text-align: center;
      padding: 0.15rem 0.15rem;
      margin-bottom: 0;
    }

    // .four-rows{
    // 	width:25%;
    // 	height: 25%;
    // }
    // .three-rows{
    // 	width:33.33%;
    // 	height:33.33%;
    // }
    img {
      // background: white;
      border-radius: 10px;
      width: 100%;
      height: 100%;
    }
  }

  .relation_580 {
    padding: 0.3rem 0.6rem 0 0.6rem;
  }

  .one-column {
    flex-direction: column;
    align-items: flex-start;
  }
}

.views {
  text-align: right;
  color: #ffffff;
  background-image: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.5)
  );
  line-height: 30px;
  height: 30px;
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: 0 10px;
}

.adver_img {
  width: 100%;

  img {
    width: 100%;
  }
}

.sp_btn {
  position: absolute !important;
  bottom: 30px !important;
  width: 80px !important;
}

.van-search__content {
  background-color: #ffffff;
}

.van-search {
  background-color: transparent;
}

.fixed_h {
  height: 31.5vh;
}

@media screen and (min-width: 550px) {
  .fixed_h {
    height: 340px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/Index.vue